import React from 'react';
import Key from './Key';
import { SpecialKeys } from '../../../shared/utils';

const Keyboard = () => {
  return (
    <div className="keyboardContainer">
      <div className="keyRow">
        {['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'].map((key) => (
          <Key
            value={key}
            key={key}
          />
        ))}
      </div>
      <div className="keyRow">
        {['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'].map((key) => (
          <Key
            value={key}
            key={key}
          />
        ))}
      </div>
      <div className="keyRow">
        <Key value={SpecialKeys.Enter}/>
        {['Z', 'X', 'C', 'V', 'B', 'N', 'M'].map((key) => (
          <Key
            value={key}
            key={key}
          />
        ))}
        <Key value={SpecialKeys.Delete}/>
      </div>
    </div>
  );
};

export default Keyboard;